(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tcv-delivery-estimate"] && !Shopify.designMode) return;
  try {
    (() => {
    const deliveryWindows = [          { countries: 'GB GG JE', min: 2, max: 3 },          { countries: 'AD MC VA SM', min: 3, max: 4 },          { countries: 'BE XK MD ME MK UA FR DE IE NL CZ ES SE AT HR LU PL DK EE HU IT BG RO SK LT PT CY GR MT SI FO FI GI IS LV LI NO RS CH TR', min: 3, max: 5 },          { countries: 'ZA AU CA CN GL HK IN IL JP MY MX NZ QA SG SA TW AE US', min: 6, max: 7 }        ];                const extraLargeProducts = new Set(['9518215561520', '15618988441982', '15618988540286', '15856492740990', '15856493199742', '15856493953406', '15896080482686']);        const formatDate = new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });        const ukClock = new Intl.DateTimeFormat('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit', timeZone: 'Europe/London' });        const day = date => date.getUTCDay();        const advance = (date, count = 1) => new Date(date.getTime() + count * 86400000);        const iso = date => date.toISOString().slice(0, 10);          function ukHoliday(date) {          const year = date.getUTCFullYear();          const firstMonday = month => {            const first = new Date(Date.UTC(year, month, 1));            return advance(first, (8 - day(first)) % 7);          };          const lastMonday = month => {            const last = new Date(Date.UTC(year, month + 1, 0));            return advance(last, -((day(last) + 6) % 7));          };          const a = year % 19, b = Math.floor(year / 100), c = year % 100;          const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);          const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;          const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k + 7) % 7;          const m = Math.floor((a + 11 * h + 22 * l) / 451);          const easterMonth = Math.floor((h + l - 7 * m + 114) / 31) - 1;          const easterDay = ((h + l - 7 * m + 114) % 31) + 1;          const easter = new Date(Date.UTC(year, easterMonth, easterDay));          const holidays = new Set([iso(advance(easter, -2)), iso(advance(easter)), iso(firstMonday(4)), iso(lastMonday(4)), iso(lastMonday(7))]);          let newYear = new Date(Date.UTC(year, 0, 1));          while (day(newYear) === 0 || day(newYear) === 6) newYear = advance(newYear);          holidays.add(iso(newYear));          let christmas = new Date(Date.UTC(year, 11, 25));          while (day(christmas) === 0 || day(christmas) === 6) christmas = advance(christmas);          holidays.add(iso(christmas));          let boxing = new Date(Date.UTC(year, 11, 26));          while (day(boxing) === 0 || day(boxing) === 6 || holidays.has(iso(boxing))) boxing = advance(boxing);          holidays.add(iso(boxing));          return holidays.has(iso(date));        }          const dispatchOpen = date => day(date) !== 0 && day(date) !== 6 && !ukHoliday(date) && !(iso(date) >= '2026-09-29' && iso(date) <= '2026-10-05');          function todayInUK() {          const parts = Object.fromEntries(ukClock.formatToParts(new Date()).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));          return new Date(Date.UTC(parts.year, parts.month - 1, parts.day));        }          function nextDispatch(today) {          let date = advance(today);          for (let i = 0; i < 370 && !dispatchOpen(date); i++) date = advance(date);          return date;        }          function arrival(dispatchDate, workingDays, includeSaturday) {          let date = dispatchDate;          let counted = 0;          while (counted < workingDays) {            date = advance(date);            if (day(date) !== 0 && (includeSaturday || day(date) !== 6) && (!includeSaturday || !ukHoliday(date))) counted++;          }          return date;        }          function displayDate(date, today) {          return formatDate.format(date) + (date.getUTCFullYear() !== today.getUTCFullYear() ? ' ' + date.getUTCFullYear() : '');        }          

    const instances = new Map();
    const countrySelector = '.oct-calculator-field-country';

    function countryNames(calculator) {
      const names = new Map();
      if (!calculator) return names;
      for (const attribute of calculator.attributes) {
        const match = attribute.name.match(/^data-country_name_([a-z]{2})$/);
        if (match) names.set(match[1].toUpperCase(), attribute.value);
      }
      return names;
    }

    function selectedCountry(calculator, names, fallback) {
      if (!calculator) return fallback;
      const field = calculator.querySelector(countrySelector);
      if (field && names.has(field.value)) return field.value;
      const address = calculator.querySelector('.oct-calculator-result-address-text')?.textContent?.trim();
      if (address) {
        for (const [code, name] of names) {
          if (address === name || address.endsWith(', ' + name)) return code;
        }
      }
      try {
        const savedCountry = JSON.parse(sessionStorage.getItem('address'))?.country;
        if (names.has(savedCountry)) return savedCountry;
      } catch {}
      return fallback;
    }

    function initialize(scope = document) {
      scope.querySelectorAll('.tcv-delivery-estimate').forEach(root => {
        if (instances.has(root)) return;
        const calculator = root.closest('.product-info')?.querySelector('.tcv-postage-card .js--calculator-product-container');
        const names = countryNames(calculator);
        const destination = root.querySelector('.tcv-delivery-estimate__destination');
        const output = root.querySelector('.tcv-delivery-estimate__result');
        const meta = root.querySelector('.tcv-delivery-estimate__meta');
        const disclaimer = root.querySelector('.tcv-delivery-estimate__disclaimer');
        let lastRender = '';

        function render(country = selectedCountry(calculator, names, root.dataset.country)) {
          const today = todayInUK();
          const renderKey = country + ':' + iso(today);
          if (lastRender === renderKey) return;
          lastRender = renderKey;
          root.dataset.currentCountry = country;
          destination.textContent = names.get(country) || root.dataset.countryName || country;
          disclaimer.textContent = country === 'GB' ? root.dataset.estimateNote : root.dataset.internationalNote;
          const dispatchDate = nextDispatch(today);
          meta.textContent = root.dataset.dispatchLabel.replace('__DATE__', displayDate(dispatchDate, today));
          if (extraLargeProducts.has(root.dataset.productId)) {
            output.textContent = root.dataset.extraLargeLabel;
            return;
          }
          const deliveryWindow = deliveryWindows.find(item => item.countries.split(' ').includes(country));
          if (!deliveryWindow) {
            output.textContent = root.dataset.unavailableLabel;
            return;
          }
          const includeSaturday = country === 'GB';
          const from = arrival(dispatchDate, deliveryWindow.min, includeSaturday);
          const to = arrival(dispatchDate, deliveryWindow.max, includeSaturday);
          output.textContent = displayDate(from, today) + ' – ' + displayDate(to, today);
        }

        const changeCountry = event => {
          if (event.target.matches(countrySelector) && names.has(event.target.value)) render(event.target.value);
        };
        let observer;
        if (calculator) {
          calculator.addEventListener('change', changeCountry);
          observer = new MutationObserver(() => render());
          observer.observe(calculator, { childList: true, subtree: true, characterData: true });
        }
        instances.set(root, () => {
          observer?.disconnect();
          calculator?.removeEventListener('change', changeCountry);
        });
        render();
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    document.addEventListener('shopify:section:unload', event => {
      for (const [root, cleanup] of instances) {
        if (event.target.contains(root)) { cleanup(); instances.delete(root); }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
